export default function PromoPerk({ apiPerk, perkTaxonomies }) {
  let name = apiPerk.name;
  let iconSrc = '';
  let iconAlt = '';
  let perk = perkTaxonomies.find(p => {
    if (apiPerk.__typename === 'property') {
      return p;
    } else if (p.api_name === apiPerk.value && p.perk_type === apiPerk.__typename) {
      return p;
    }
  });

  if (perk) {
    name = perk.name;
    iconSrc = perk.icon_src;
    iconAlt = perk.icon_alt;
  }

  return (
    <div className="perk d-flex align-items-center gap-2">
      <img
        src={iconSrc}
        alt={iconAlt}
        width="40"
        height="40"
      />
      <span className="text-info label-1">{name}</span>
    </div>
  );
}
